<p>{{ displayValue | timerFormat }}</p>
